<template lang="pug">
div(@click="downloadQrcode" ref="qrcode")

</template>


<script>
import QRCodeStyling from "@nimashoghi/qr-code-styling"
let fontSizeCanvas

export default {
  props: ['input', 'text', 'file'],
  data() {
    return {
      qrCodeEl: null,
    }
  },
  mounted() {
    this.qrCodeEl = new QRCodeStyling()
    this.qrCodeEl.append(this.$refs.qrcode)
    if (!fontSizeCanvas) {
      fontSizeCanvas = document.createElement('canvas', { width: 1, height: 1 })
    }
    this.$nextTick(this.updateQrCode)
  },
  beforeDestroy() {
    this.qrCodeEl = null
  },
  watch: {
    input() {
      this.updateQrCode()
    },
    text() {
      this.updateQrCode()
    },
  },
  methods: {
    downloadQrcode() {
      this.qrCodeEl.download({ name: this.file || `HVD-QR-${this.text || this.input || ''}`, skipDownload: false })
    },
    calcFontSize(ctx, lines, width, min = 4, max = 100) {
      ctx.font = `10px monospace`
      let longestLine = ''
      let longestLineLength = 0
      lines.forEach((line) => {
        let w = ctx.measureText(line).width
        if (longestLineLength < w) {
          longestLineLength = w
          longestLine = line
        }
      })
      let size, mid
      for (let i=0; i<10; i++) {
        mid = (max + min) / 2
        ctx.font = `${mid}px monospace`
        size = ctx.measureText(longestLine)
        if (size.width == width) {
          return ctx.font
        } else if (size.width < width) {
          min = mid
        } else {
          max = mid
        }
      }
      return ctx.font
    },
    updateQrCode() {
      const qrCodeEl = this.qrCodeEl
      if (!qrCodeEl) {
        return
      }

      const w = 320
      const m = 5
      const text = this.text || ''
      const withText = !!text
      let font
      let lineHeight = 0
      const lines = text.split("\n")
      if (withText) {
        const fontCtx = fontSizeCanvas.getContext("2d")
        font = this.calcFontSize(fontCtx, lines, w-m*2)
        lineHeight = fontCtx.measureText('M').width * 1.6 // approximate line height
      }

      const h = w + (withText ? m + lines.length * lineHeight : 0)
      qrCodeEl.update({
        width: w,
        height: h,
        margin: m,
        data: this.input || '',
        image: require("../../../app/assets/images/logo-x-qr.svg"),
        errorCorrectionLevel: "H",
        dotsOptions: {
          color: "#000",
          type: "square"
        },
        backgroundOptions: {
          color: "#fff",
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 0,
          imageSize: 0.4,
          hideBackgroundDots: false,
        }
      })

      if (withText && qrCodeEl._drawingPromise) {
        qrCodeEl._drawingPromise.then(() => {
          const ctx = qrCodeEl._canvas.getCanvas().getContext("2d")
          ctx.save()
          ctx.drawImage(ctx.canvas, 0, -(h-w)/2)
          ctx.font = font
          ctx.textAlign = "center"
          ctx.textBaseline = 'top'
          ctx.fillStyle = "#000000"
          lines.forEach((line, i) => {
            ctx.fillText(line, w/2, w + lineHeight * i, w)
          })
          ctx.restore()
        })
      }
    },
  },
}
</script>
